import { KpiKeys, KpisByKey } from '@models';

const PORTFOLIO_KPIS: KpiKeys[] = [
  'days_to_close_site_findings',
  'key_milestones_on_track_to_baseline',
  'non_enrolling_sites'
];

const EMPTY_PORTFOLIO_KPIS: KpisByKey = {
  days_to_close_site_findings: {
    name: 'Days to close site findings',
    type: 'days',
    value: undefined,
    numerator: undefined,
    denominator: undefined,
    health: 'no-data',
    trendText: '--',
    trendIndicator: undefined,
    trendChange: undefined,
    message: 'No data available'
  },
  enrollment: {
    name: 'Non-enrolling sites',
    type: 'number',
    value: undefined,
    numerator: undefined,
    denominator: undefined,
    health: 'no-data',
    trendText: '--',
    trendIndicator: undefined,
    trendChange: undefined,
    message: 'No data available'
  },
  key_milestones_on_track_to_baseline: {
    name: 'Key milestones on track to baseline',
    type: 'percent',
    value: undefined,
    numerator: undefined,
    denominator: undefined,
    health: 'no-data',
    trendText: '--',
    trendIndicator: undefined,
    trendChange: undefined,
    message: 'No data available'
  }
};

export { EMPTY_PORTFOLIO_KPIS, PORTFOLIO_KPIS };
